
		<div
			class="dynamic-field form-group"
			[class.has-error]="OBJ_select?.invalid">
			<label class="col-lg-3 control-label">{{getLabelName()|translate}}
				<span *ngIf="isRequired()" class="tgi-asterisk"> *</span>
			</label>
			<div class="col-lg-8">
				<select #OBJ_select="ngModel"
					[required]="isRequired()"
					class="form-control"
					name="OBJ_field_config.name"
					[(ngModel)]="OBJ_data?.ids[0]">
					<option value="">{{"please_select"|translate}}</option>
					<option *ngFor="let OBJ_option of ARR_options" value="{{OBJ_option?.id}}">
						{{OBJ_option?.title}}
					</option>
				</select>
				<span class="help-block m-b-none" *ngIf="OBJ_select?.invalid">
                  {{'oError.sRequired'|translate}}
                </span>
				<!--<tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>-->
			</div>
		</div>
	